import React, { useState, useContext, useEffect } from "react";

import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import GenericModal from "src/GenericModal";

import BackArrow from "../../atoms/backArrow/backArrow";
import { makeAPICall } from "../../services/apiService";
import GreenArrow from "../../assets/landing-page/arrow-green.svg";
import checked from "../../assets/fieldIcons/checked.svg"
import exchangeIcon from "../../assets/images/swap.svg"
import DeleteIcon from "../../assets/images/deleteOrderIcon.svg"
import "./exchange.scss";
import { getCookie, getPaymentAmout } from "../../utils/utils";

const ScooterExchangeData = () => {
  const history = useHistory();
  const [verifyPopup, setVerifyPopup] = useState(false);
  const [rejectPopup, setRejectPopup] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");
  const [otherRemarks, setOtherRemarks] = useState("")
  const [partnerName, setPartnerName] = useState("")
  const [orderData, setOrderData] = useState(
    {}
    );
  const [orderUserData, setOrderUserData] = useState({})
  const [colorGroups, setColorGroups] = useState({})
  const ownershipMap = { 1: "First", 2: "Second", 3: "Third", 4: "Fourth", 5: "Fifth" };
  const [list, setList] = useState({
     "Partner Name":partnerName,
    Brand: orderData.brand,
    "Model": orderData.model,
    "Variant": orderData?.variant,
    "Color": colorGroups[orderData?.color]?.join("/"),
    "Year Of registration": orderData?.year,
    // "Pincode": orderData?.pin_code,
    "Loan status": orderData?.other_attributes?.loan_status,
    "Running condition": orderData?.other_attributes?.running_condition,
    "KM range": orderData.from_distance + " - " + orderData.to_distance + "KM",
    "Owner name": orderData.owner_name,
    "Exchange Value": orderData?.exchange_value && getPaymentAmout(orderData?.exchange_value),
    "Registration Number": orderData?.other_attributes?.registration_number,
    "Ownership": ownershipMap[orderData?.other_attributes?.ownership],
    // "Transaction Id": orderData.transaction_id
  });
  const rejectReasons = [
    "Booked by mistake",
    "Not available at moment will take TR later",
    "Ola Brand Champion is not reachable",
    "Ola Brand Champion did not arrive on time",
    "Ola Brand Champion refused to come/denied duty",
    "Directly interested in purchase, test ride is not required",
    "Not looking to buy right now, might buy in future",
    "Not in good condition",
    "Details entered are wrong",
    "Others",
  ];
  const [loader, setLoader] = useState(false);

  //images states
  const [vehicleImages, setVehicleImages] = useState([])
  const [registrationImages, setRegistrationImages] = useState([])
  const [form30Images, setForm30Images] = useState([])
  const [kycImages,setKycImages]=useState([])
  const [optionalImages, setOptionalImages] = useState([])
  const [toastMsg, setToastMsg] = useState("")
  const [showToggle, setShowToggle] = useState(false)
  const [previousDocStatus,setPreviousDocStatus]=useState({})
  console.log('previousDocStatus:', previousDocStatus)

  const vehConditionLimit = 3

  useEffect(() => {
    setList(
      {
        "Partner Name":partnerName,
       Brand: orderData.brand,
       "Model": orderData.model,
       "Variant": orderData?.variant,
       "Color": colorGroups[orderData?.color]?.join("/") || orderData?.color,
       "Year Of registration": orderData?.year,
      //  "Pincode": orderData?.pin_code,
       "Loan status": orderData?.other_attributes?.loan_status,
       "Running condition": orderData?.other_attributes?.running_condition,
       "KM range": orderData.from_distance + " - " + orderData.to_distance + "KM",
       "Owner name": orderData.owner_name,
       "Exchange Value": orderData?.exchange_value && getPaymentAmout(orderData?.exchange_value),
       "Registration Number": orderData?.other_attributes?.registration_number,
       "Ownership": ownershipMap[orderData?.other_attributes?.ownership],
      //  "Transaction Id": orderData.transaction_id
     }
    )
  }, [orderData, partnerName, colorGroups])

  useEffect(() => {
    if (orderData?.order_id) {
      getPreviousDocStatus()
    }
  }, [orderData])

  function getPartnerArray(element) {
    let payload = {
      method: "get",
      url: 'api/exchange/exchangePatnerData'
    }
    makeAPICall(payload)
      .then((response) => {
        let partner_Details = response?.data?.data.find((el) => el?.id === element?.other_attributes?.partner_id)
        setPartnerName(partner_Details?.partner_name)
      })
      .catch((err) => {
        console.log("error in getting patner data", err);
        // toggleToaster(`Somethin went wrong`)
      })
  }

  const getExchangeStaticData = async () => {
    const response = await (await fetch("api/exchange/getExchangeStaticData")).json();
    console.log(response.color_groups, "color")
    setColorGroups(response.color_groups)
}

  useEffect(() => {
    if (history?.location?.state?.showtoggle) {
      toggleToaster("Offer sent for verification")
    }
    getExchangeStaticData()
    setOrderUserData(history.location.state)
   
        let config = {
          method: "get",
          url: `api/exchange/getExchangeOrderDetail`,
          params: {
            ...history.location.state,
          },
        };
  
        makeAPICall(config)
          .then((resp) => {
            if (resp && resp.data.status === "SUCCESSFUL") {
              console.log("success");
              if (resp?.data?.data?.other_attributes?.partner_id) {
                getPartnerArray(resp?.data?.data)
              }
              setOrderData(resp.data.data);
              setLoader(false);
            }
          })
          .catch((err) => {
            console.log("failed");
            setLoader(false);
          });
    // for (let i = 1; i <= vehConditionLimit; i++) {
    //   retrieveDocs(`VEHICLE_CONDITION_${i}`)
    // }
  }, []);

  const getPreviousDocStatus = () => {
    let config = {
      method: "get",
      url: `api/exchange/previousdocstatus?order_id=${orderData?.order_id}`,
    };
    makeAPICall(config)
      .then((res) => {
        setPreviousDocStatus(res?.data?.data)
      })
      .catch((err) => {
      console.log("err in previous doc",err);
    })
  }
  
  const toggleToaster = (msg, time = 2000) => {
    setShowToggle(true)
    setToastMsg(msg)
    setTimeout(() => {
      setShowToggle(false)
      setToastMsg("")
    }, time)
  }

  useEffect(() => {
    if (previousDocStatus?.exchange_uploaded_docs) {
      getPreviousImages()
    }
  }, [previousDocStatus])

  const getPreviousImages = async () => {
    try {
      let arrayOfVehicleImages = []
      let arrayOfOptionalImages = []
      let arrayOfKycImages=[]
      let vimages = []
      let opimages = []
      let kimages=[]
        for (let i = 0; i < previousDocStatus.exchange_uploaded_docs.length; i++) {
          if (Object.keys(previousDocStatus.exchange_uploaded_docs[i]) == "OLD_2_WHEELER_PICTURES") {
            vimages = Object.values(previousDocStatus.exchange_uploaded_docs[i])
          }
        }
      if (vimages.length > 0) {
        vimages = vimages.flat()
      }
        for (let i = 0; i < vimages.length; i++){
          arrayOfVehicleImages.push(retrieveDocs(vimages[i]))
        }
      // let vehicle1 = retrieveDocs(`VEHICLE_CONDITION_1`)
      // let vehicle2 = retrieveDocs(`VEHICLE_CONDITION_2`)
      // let vehicle3 = retrieveDocs(`VEHICLE_CONDITION_3`)
      let vehicleImages = await Promise.all(arrayOfVehicleImages)
      let formatvehicleImages = [];
      vehicleImages.forEach((el) => {
        let arrLength = el?.data?.data?.files
        for (let i = 0; i < arrLength.length; i++){
          // el?.data?.data?.files?.forEach((item) => {
            // console.log(item,"llldldldl");
            formatvehicleImages.push(arrLength[i]);
          // })
        }
       })
      setVehicleImages(formatvehicleImages)
      let scooter_images = await retrieveDocs("SCOOTER_REGISTRATION")
      console.log('scooter_images:111', scooter_images)
      setRegistrationImages(scooter_images?.data?.data?.files)

      let form29 = retrieveDocs("EXCHANGE_FORM_29")
      let form30 = retrieveDocs("EXCHANGE_FORM_30")
      let formImages = await Promise.all([form29, form30])
      let formFormatIamges = [];
      formImages.forEach((el) => {
        let arrLength = el?.data?.data?.files
        for (let i = 0; i < arrLength.length; i++) {
          // el?.data?.data?.files?.forEach((item) => {
          // console.log(item,"llldldldl");
          formFormatIamges.push(arrLength[i]);
          // })
        }
      })
      setForm30Images(formFormatIamges)
      
      // let kyc1 = retrieveDocs("EXCHANGE_AUTH_LETTER")
      // let kyc2 = retrieveDocs("EXCHANGE_KYC_DOC")

      for (let i = 0; i < previousDocStatus.exchange_uploaded_docs.length; i++) {
        if (Object.keys(previousDocStatus.exchange_uploaded_docs[i]) == "KYC_AUTH_LETTER") {
          kimages = Object.values(previousDocStatus.exchange_uploaded_docs[i])
        }
      }

      if (kimages.length > 0) {
        kimages = kimages.flat()
      }
      for (let i = 0; i < kimages.length; i++) {
        arrayOfKycImages.push(retrieveDocs(kimages[i]))
      }

      let getkycImages = await Promise.all(arrayOfKycImages)
      let kycFormatImages = []
      getkycImages.forEach((el) => {
        let arrLength = el?.data?.data?.files
        for (let i = 0; i < arrLength.length; i++) {
          // el?.data?.data?.files?.forEach((item) => {
          // console.log(item,"llldldldl");
          kycFormatImages.push(arrLength[i]);
          // })
        }
      })
      setKycImages(kycFormatImages)
      for (let i = 0; i < previousDocStatus.exchange_uploaded_docs.length; i++) {
        if (Object.keys(previousDocStatus.exchange_uploaded_docs[i]) == "EXCHANGE_OPTIONAL_DOC") {
          opimages = Object.values(previousDocStatus.exchange_uploaded_docs[i])
        }
      }
      if (opimages.length > 0) {
        opimages = opimages.flat()
      }
      for (let i = 0; i < opimages.length; i++) {
        arrayOfOptionalImages.push(retrieveDocs(opimages[i]))
      }
      // let optional1 = retrieveDocs(`EXCHANGE_OPTIONAL_DOC_1`)
      // let optional2 = retrieveDocs(`EXCHANGE_OPTIONAL_DOC_2`)
      // let optional3 = retrieveDocs(`EXCHANGE_OPTIONAL_DOC_3`)
      let optionalImages = await Promise.all(arrayOfOptionalImages)
      let formatOptionalImages = [];
      optionalImages.forEach((el) => {
        let arrLength = el?.data?.data?.files
        for (let i = 0; i < arrLength.length; i++) {
          // el?.data?.data?.files?.forEach((item) => {
          // console.log(item,"llldldldl");
          formatOptionalImages.push(arrLength[i]);
          // })
        }
      })
      setOptionalImages(formatOptionalImages)
    }
    catch(err) {
      console.log("something went wrong");
    }
  }
  const retrieveDocs = (type, ind) => {
    let config = {
      method: "get",
      url: `api/exchange/retrieve-docs`,
      headers: {
        oem_auth_token: getCookie("oem_auth_token")
      },
      params: {
        ...history.location.state,
        order_id: history.location.state.order_id,
        type: type,
      },
    };

    return makeAPICall(config);
      // .then((resp) => {
      //   if (type == "SCOOTER_REGISTRATION") {
      //     setRegistrationImages(resp.data.data.files)
      //   } else if (type == "EXCHANGE_FORM_29") {
      //     setForm29Images(resp.data.data.files)
      //   } else if (type == "EXCHANGE_FORM_30") {
      //     setForm30Images(resp.data.data.files)
      //   }
      //   else if (type == "EXCHANGE_AUTH_LETTER") {
      //     setOptionalImages(...optionalImages, resp.data.data.files)
      //   } else if (type == "EXCHANGE_KYC_DOC") {
      //     setOptionalImages(...optionalImages, resp.data.data.files)
      //   }
      //   else if (type.includes("VEHICLE_CONDITION_")){
      //     // setVehicleImages([...vehicleImages,...resp?.data?.data.files])
      //     return resp?.data?.data.files
      //   }
      // })
      // .catch((err) => {
      //   console.log("failed",err);
      //   // toggleToaster(`Somethin went wrong`)
      // });
  }

  const disableReject = () => {
    if(rejectMessage === "" || rejectMessage === "Others" && otherRemarks === "") {
      return true
    } else {
      return false
    }
  }

  const verifyExchange = (types) => {
    // if(types === "REJECTED" && rejectMessage === "" || types === "REJECTED" && rejectMessage === "Others" && otherRemarks === "") {
    //   return
    // }
    // if (types == "VERIFIED") {
    //   setVerifyPopup(false);
    //   return
    // } else {
    //   setRejectPopup(false);
    // }

    let config = {
      method: "put",
      url: `api/exchange/verifyExchange`,
      params: {
        ...orderUserData,
      },
      data: {
        status: types,
        message: otherRemarks || rejectMessage || "",
      },
    };

    makeAPICall(config)
      .then((resp) => {
        if (resp && resp.data.status === "SUCCESSFUL") {
          setLoader(false);
          history.replace("/booking-list")
        }
      })
      .catch((err) => {
        console.log("failed");
        setLoader(false);
      });

  };

  const removeExchangeOffer = () => {
    setLoader(true); 
    let config = {
      method: "delete",
      url: `api/exchange/deleteExchangeDetail`,
      params: {
        ...history.location.state,
      },
    };

    makeAPICall(config)
      .then((resp) => {
        if (resp && resp.data.status === "SUCCESSFUL") {
          setLoader(false);
        }
        history.push("/search-exchange")
      })
      .catch((err) => {
        setLoader(false);
      });
  }
  const orderStatus = () => {
    switch (orderData?.status) {

      case "PENDING": return <div className="orderStatus">
        <span class="dot"></span> <span className="subDesc pending">Waiting for approval</span>
      </div>

      case "DRAFT": return <div className="orderStatus">
        <span class="dot"></span> <span className="subDesc pending">Waiting for approval</span>
      </div>

      case "VERIFIED": return <div className="orderStatus">
        <span class="dot"></span> <span className="subDesc ">Verified</span>
      </div>

      case "APPROVED": return <div className="orderStatus">
        <span class="dot"></span> <span className="subDesc">Approved</span>
      </div>

      case "REJECTED": return <div className="orderStatus">
        <span class="dot"></span> <span className="subDesc rejected">Rejected</span>
      </div>

      case "PAYMENT_RECEIVED": return <div className="orderStatus">
        <span class="dot"></span> <span className="subDesc "> Vendor Payment Received</span>
      </div>

      case "PAYMENT_FAILED": return <div className="orderStatus">
        <span class="dot"></span> <span className="subDesc rejected">Vendor Payment Failed, Request has been resent</span>
      </div>

      case "PAYMENT_SETTLED": return <div className="orderStatus">
        <span class="dot"></span> <span className="subDesc">Scooter Ordered</span>
      </div>

      case "CANCELLED": return <div className="orderStatus">
        <span class="dot"></span> <span className="subDesc rejected">Exchange Cancelled</span>
      </div>

      case "EXCHANGE_FAILED": return <div className="orderStatus">
        <span class="dot"></span> <span className="subDesc rejected">Exchange Failed</span>
      </div>
    }
  }
  return (
    <div className="loan-container">
      <div>
        <div className="backArrow">
          <Link to="/search-exchange">
            <BackArrow removeClass={true} />
          </Link>
        </div>
        <div className="header-text"></div>
      </div>
      {orderData ? (
        <div className="dataCont">
          <div>
            <div className="nameHead">{orderData.owner_name}</div>
            <div className="descOrderId">{orderData.order_id}
            {/* {
              history?.location?.state?.action == "EXCHANGE_COMPLETED" && (
                <><span class="dot"></span> <span className="subDesc">Completed</span></>
              )
            }

            {
              history?.location?.state?.action == "VIEW_EDIT" && (
                <><span class="dot"></span> <span className="subDesc">Saved</span></>
              )
            } */}
              {orderStatus()}
            </div>
          </div>
          {orderData?.status === "REJECTED" && orderData?.message && <div className="rejected-reason">{orderData?.message}</div>}
          {showToggle && <div className="toaster">{toastMsg}</div>}

          {
            // (orderUserData?.action == "VERIFY_EXCHANGE" || orderUserData?.action == "VIEW_EDIT")
           (orderData?.status === "REJECTED" || orderData?.status === "DRAFT")
            && (
              <div className="exchange-redit-remove-cta">
                <div
                  className="editDetails"
                  onClick={() => history.push({
                    pathname: `/scooter-exchange-edit`,
                    state: {
                      ...orderUserData
                    }
                  })}
                  >
                  Edit Details <img src={GreenArrow} />
                </div>
                <div className="removeExchangeCta" onClick={() => {
                  removeExchangeOffer()
                }}>Remove</div>
                </div>
            )
          }
          

          {Object.keys(list).map((keys) => (
            <div className="keyCont">
              <div className="listkey">{keys}</div>
              <div className="listvalue">{list[keys]}</div>
            </div>
          ))}

          {vehicleImages.length > 0 &&
            <div className="customer-2wheeler-images-wrapper">
              <div className="customer-2wheeler-images-title">2-wheeler pictures</div>
              <div className="customer-2wheeler-images-section">
                {vehicleImages.map((el, i) =>
                  <div key={i}>
                    <img className="customer-2wheeler-image" src={el?.file} alt="" />
                  </div>
                )}
              </div>
            </div>
          }

          {registrationImages.length > 0 &&
            <div className="customer-2wheeler-images-wrapper">
              <div className="customer-2wheeler-images-title">Registration certificate</div>
              <div className="customer-2wheeler-images-section">
                {registrationImages.map((el, i) =>
                  <div key={i}>
                    <img className="customer-2wheeler-image" src={el?.file} alt="" />
                  </div>
                )}
              </div>
            </div>
          }

          {form30Images.length > 0 &&
            <div className="customer-2wheeler-images-wrapper">
              <div className="customer-2wheeler-images-title">Form 29 & 30</div>
              <div className="customer-2wheeler-images-section">
                {form30Images.map((el, i) =>
                  <div key={i}>
                    <img className="customer-2wheeler-image" src={el?.file} alt="" />
                  </div>
                )}
              </div>
            </div>
          }

          {kycImages.length > 0 &&
            <div className="customer-2wheeler-images-wrapper">
              <div className="customer-2wheeler-images-title">KYC Images</div>
              <div className="customer-2wheeler-images-section">
                {kycImages.map((el, i) =>
                  <div key={i}>
                    <img className="customer-2wheeler-image" src={el?.file} alt="" />
                  </div>
                )}
              </div>
            </div>
          }

          {optionalImages.length > 0 &&
            <div className="customer-2wheeler-images-wrapper">
              <div className="customer-2wheeler-images-title">Optional Images</div>
              <div className="customer-2wheeler-images-section">
                {optionalImages.map((el, i) =>
                  <div key={i}>
                    <img className="customer-2wheeler-image" src={el?.file} alt="" />
                  </div>
                )}
              </div>
            </div>
          }


          
          {/* <div className="btn-cont">
            <button onClick={() => setRejectPopup(true)} className="sec-btn">
              Reject
            </button>
            <button
              onClick={() => {
                history.push({
                pathname: `/upload-scooter`,
                search: `?order_id=${orderData.order_id}`,
                state: {
                  ...history.location.state
                }
              })
            }}
              className="primary-btn"
            >
              Upload Docs
            </button>
          </div> */}
          {
            (history?.location?.state?.action == "VERIFY_EXCHANGE") && (
            <div className="btn-cont">
              <button className="sec-btn" onClick={() => { 
                // setRejectPopup(true)
                removeExchangeOffer()
              }}>
                Reject
              </button>
              <button
                className="primary-btn"
                onClick={() => {
                  setVerifyPopup(true)
                }}
              >
              Verify
              </button>
            </div>
            ) 
          }

           {
            (history?.location?.state?.action != "VERIFY_EXCHANGE") && (
            <div className="btn-cont">
               {/* {orderUserData?.action == "VIEW_EDIT" && <button className="sec-btn full-width" onClick={() => { 
                removeExchangeOffer()
              }}>
                Remove
              </button>} */}
              <button
                className="primary-btn full-width"
                onClick={() => {
                  history.push("/search-exchange")
                }}
              >
               Okay
              </button>
            </div>
            ) 
          }
        </div>
      ) : (
        <div>Something went wrong Please try again later...</div>
      )}
      {verifyPopup && (
        <GenericModal onClose={() => setVerifyPopup(false)} showClose={false}>
          <div className="popupHead">
            <div>Are you sure want to verify this exchange?</div>
            <img src={exchangeIcon} alt="exchangeIcon" />
          </div>

          <div className="popup-sub">
            Make sure you have checked all the properties mentioned
          </div>
          <div className="popup-btn">
            <button className="sec-btn" onClick={() => setVerifyPopup(false)}>
              Dismiss
            </button>
            <button
              onClick={() => verifyExchange("VERIFIED")}
              className="primary-btn"
            >
              Verify
            </button>
          </div>
        </GenericModal>
      )}
      {rejectPopup && (
        <GenericModal onClose={() => setRejectPopup(false)} showClose={false} fullScreen={true}>
          <div className="backArrow" onClick={() => setRejectPopup(false)}>
              <BackArrow removeClass={true} />
          </div>
          <div style={{margin: '16px'}}>
          <div className="header-text">Please select reason for rejection</div>
          {rejectReasons.map((rej, i) => (
            <div onClick={() => setRejectMessage(rej)}>
              <div className="radioCont">
              <div className="imgCont">{rej === rejectMessage ? <img src={checked} alt="checked"/> : <div className="greyIcon"></div>}</div>
              <div>{rej}</div>
              </div>
              {rejectMessage === "Others" && rej === "Others" && <textarea className="otherText" value={otherRemarks} onChange={(e) => setOtherRemarks(e.target.value)}></textarea>}
            </div>
          ))}
          <div>
            <button
              onClick={() => verifyExchange("REJECTED")}
              className="primary-btn"
              style={{cursor: disableReject() ? "no-drop" : "pointer", background: disableReject() ? "rgba(0, 0, 0, 0.36)" : "black", width: '100%' }}
            >
              Reject
            </button>
          </div>
          </div>
        </GenericModal>
      )}
    </div>
  );
};

export default ScooterExchangeData;
